import React from 'react';
import styled from 'styled-components';
import { useFixedSurface } from 'students/views/shared/providers/Theme';
import MessagesIcon from './icons/Messages';

interface IProps {
  className?: string;
}

function MobileChatIcon({ className }: IProps) {
  const isFixedSurface = useFixedSurface();

  return (
    <SWrapper className={className} $isFixedSurface={isFixedSurface}>
      <lingu-button>
        <MessagesIcon />
      </lingu-button>
      <lingu-badge />
    </SWrapper>
  );
}

export default MobileChatIcon;

declare global {
  namespace JSX {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface IntrinsicElements {
      'lingu-badge': React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      > & { styles?: string };

      'lingu-button': React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      > & { styles?: string };
    }
  }
}

const SWrapper = styled.div<{ $isFixedSurface: boolean }>`
  position: relative;
  display: flex;
  justify-content: center;
  width: 40px;
  height: 32px;
  background: ${({ $isFixedSurface }) =>
    $isFixedSurface ? 'rgba(255, 255, 255, 0.15)' : 'rgb(var(--ln-overlay) / 0.15)'};
  border-radius: 100px;
  align-items: center;

  & lingu-button::part(button) {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    color: var(--color-grey);
    font-size: 0.7rem;
    white-space: nowrap;
    line-height: 1;
    outline: none;
    width: 100%;
    height: 100%;
  }

  & lingu-badge::part(badge) {
    position: absolute;
    top: 0;
    right: 1px;
    border-radius: 8px;
    background-color: #e1ff6a;
    width: 16px;
    height: 16px;
    display: flex;
    justify-content: center;
    align-items: center;

    font-size: 10px;
    font-weight: 700;
    color: #050d2c;

    pointer-events: none;
  }

  & svg path {
    fill: rgb(var(--ln-content));
  }

  &.active {
    text-decoration: none;
  }
`;
